import React from 'react';
import { useSelector } from 'react-redux';

import { companyTitles } from '../../constants/companies';
import { getCurrentCompany } from '../../store/selectors';
import { formatNumber } from '../../helpers/companiesHelper';

function CompanyDataItem({ title }) {
  const dataTitle = companyTitles[title];
  const value = useSelector(getCurrentCompany)[title];
  const dataValue = typeof value === 'string' && value ? formatNumber(value, title) : '-';

  return (
    <>
      <div className="company-item-title">
        {typeof dataTitle === 'string' && dataTitle}
      </div>
      <div>{dataValue}</div>
    </>
  );
}

export default CompanyDataItem;
